import { render, staticRenderFns } from "./CustomResult.vue?vue&type=template&id=9918a476&scoped=true&"
import script from "./CustomResult.vue?vue&type=script&lang=js&"
export * from "./CustomResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9918a476",
  null
  
)

export default component.exports